import React, { useEffect, useState, useCallback, useRef } from "react";
import { Menu, Segment, Grid } from 'semantic-ui-react';
import "./Analytics.css"
import Simulation from './Simulation/Simulation';
import AnalyticsSection from "./AnalyticsSection/AnalyticsSection";
import Demand from "./Demand/Demand";
import UnsavedChangesTabSection from "../shared/UnsavedChangesTabSection";
import { connect } from "react-redux";
import PropTypes from 'prop-types'
import { queryReport } from "../../actions/analytics-v2";
import { getSafeSelectedWorkspace } from "../../utils/mappers/user";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import { getAllSavedSimulations, getSimulationAllowedStatus, getAnalyticsStatus } from "../../actions/analytics-v2";
import { useGuardedActiveKeyChange } from "../../hooks/useUnsavedChangesGuard";
import _ from "lodash";

const AnalyticsV2 = 
({  
    queryReport, 
    currentWorkspaceId, 
    loadingSimulationActions, 
    getAllSavedSimulations,
    getSimulationAllowedStatus,
    getAnalyticsStatus,
    analyticsChartData
}) => {

    const { t } = useTranslation()

    const menuItemNames = { firstItem: "historical", secondItem: "simulation", thirdItem: "demand" }
    const [ activeItem, setActiveItem ] = useState(menuItemNames.firstItem);
    const tabSectionRef = useRef(null);

    const menuItemComponents = {
        "historical": <AnalyticsSection />,
        "simulation": <Simulation />,
        "demand": <Demand />
    }

    const handleMenuItemClick = useGuardedActiveKeyChange(tabSectionRef, activeItem, setActiveItem);

    // Load necessary data to allow and load simulation. 
    useEffect(() => {
        if( currentWorkspaceId ){
            getSimulationAllowedStatus(currentWorkspaceId)
        }
    }, [ currentWorkspaceId, getSimulationAllowedStatus ])
    
    const getSimulationData = useCallback(() => {
        if(currentWorkspaceId){
            getAllSavedSimulations(currentWorkspaceId)
        }
    }, [ currentWorkspaceId, getAllSavedSimulations ]);

    useEffect(()=>{
        getSimulationData();
    }, [ getSimulationData, loadingSimulationActions ])


    useEffect(()=>{
        if(currentWorkspaceId){
            getAnalyticsStatus(currentWorkspaceId)
        }
    }, [currentWorkspaceId, getAnalyticsStatus])

    // Load all data for analytics section.
    useEffect(() => {
        if(currentWorkspaceId && _.isEmpty(analyticsChartData)){
            queryReport({
                        currentWorkspaceId,
                        selectedWorkspaces: [currentWorkspaceId],
                        t, 
                        fieldFilters: { }, //Empty because this useEffect is executed only first time
                        isFirstDataFetch: true,
                        includeNonBuffered: true})
        }
        // This line is used because of newGroupData
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentWorkspaceId]);

    if (!currentWorkspaceId) {
        return (
          <div className="ui container container-space">
            <Segment placeholder style={{ minHeight: "350px" }}>
              <h2>{t("workspaceRequired")}</h2>
            </Segment>
          </div>
        );
    }

    const segmentClassName = classNames({  
                                            'analytics-menu-container': true, 
                                            "analytics-height": activeItem === menuItemNames.firstItem, 
                                            "simulation-height": activeItem === menuItemNames.secondItem,
                                            "demand-height": activeItem === menuItemNames.thirdItem
                                        })


    return(
        <UnsavedChangesTabSection
            ref={tabSectionRef}
            activeKey={activeItem}
            header={t("unsavedChanges.title")}
            content={t("unsavedChanges.content")}
        >
            <Segment secondary basic className={segmentClassName}>
                <Grid>
                    <Grid.Row centered>
                        <Grid.Column widescreen={13} computer={15} tablet={15} mobile={15}>
                            <Grid.Row centered className="sub-menu-container">
                                <Menu fluid widths={3}>
                                    <Menu.Item
                                        disabled={false}
                                        active={activeItem === menuItemNames.firstItem}
                                        onClick={() => handleMenuItemClick(menuItemNames.firstItem)}
                                    >
                                        {t("analytics.historicTitle")}
                                    </Menu.Item>

                                    <Menu.Item
                                        disabled={false}
                                        active={activeItem === menuItemNames.secondItem}
                                        onClick={() => handleMenuItemClick(menuItemNames.secondItem)}
                                    >
                                        {t("simulation.title")}
                                    </Menu.Item>
                                    <Menu.Item
                                        disabled={false}
                                        active={activeItem === menuItemNames.thirdItem}
                                        onClick={() => handleMenuItemClick(menuItemNames.thirdItem)}
                                    >
                                        {t("demand.title")}
                                    </Menu.Item>

                                </Menu>
                            </Grid.Row>
                            <Grid.Row centered>
                                <Grid.Column >
                                    {menuItemComponents[activeItem]}
                                </Grid.Column>
                            </Grid.Row>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
          </Segment>
        </UnsavedChangesTabSection>
    )
}

AnalyticsV2.propTypes = {
    queryReport: PropTypes.func,
    currentWorkspaceId: PropTypes.number,
    loadingSimulationActions: PropTypes.bool,
    getAllSavedSimulations: PropTypes.func,
    getSimulationAllowedStatus: PropTypes.func,
    getAnalyticsStatus: PropTypes.func,
    analyticsChartData: PropTypes.object,
}

const mapStateToProps = (state) => ({
    currentWorkspaceId: getSafeSelectedWorkspace(state),
    loadingSimulationActions: state.analytics.loadingSimulationActions,
    analyticsChartData: state.analytics.analyticsChartData,
});
export default connect(mapStateToProps, { queryReport, 
                                            getAllSavedSimulations, 
                                            getSimulationAllowedStatus, 
                                            getAnalyticsStatus })(AnalyticsV2);